<template>
<svg :width="width" :height="height" viewBox="0 0 16 18" :fill="color" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.59 0.531C10.21 0.189 9.7 0 9.17 0H2C0.9 0 0 0.81 0 1.8V16.2C0 17.19 0.89 18 1.99 18H14C15.1 18 16 17.19 16 16.2V6.147C16 5.67 15.79 5.211 15.41 4.878L10.59 0.531ZM9 5.4V1.35L14.5 6.3H10C9.45 6.3 9 5.895 9 5.4Z" fill="#80B7FF"/>
<path xmlns="http://www.w3.org/2000/svg" d="M3 14C3 13.4477 3.44772 13 4 13H12C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15H4C3.44772 15 3 14.5523 3 14Z" fill="white"/>
<path xmlns="http://www.w3.org/2000/svg" d="M3 10C3 9.44772 3.44772 9 4 9H12C12.5523 9 13 9.44772 13 10C13 10.5523 12.5523 11 12 11H4C3.44772 11 3 10.5523 3 10Z" fill="white"/>
</svg>

</template>

<script>
import {colors} from "../../constants";

export default {
    props: {
        width: { type: [Number, String], default: 16 },
        height: { type: [Number, String], default: 18 },
        color: { type: String, default: colors.iconArinet }
    }
}
</script>
